// extracted by mini-css-extract-plugin
export default {"content":"Products_content__e4F6e","heading":"Products_heading__w8wxk"};